import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import Files from 'react-files';

import { 
  loadMedias,
  loadMedia,
  addMedia,
  editMedia,
} from '../../reducers/medias';

import update from 'immutability-helper';

import axios from 'axios';

class MediaManagerEditor extends Component {

  constructor(props) {
    super(props);

    this.video1 = React.createRef();
    this.video2 = React.createRef();
    this.video3 = React.createRef();
  }

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    media: {
      removeImage: [false, false, false],
      orientation: 'Portrait',
      content_scheduling_type_id: '1',
      external_url: ''
    },
    mediaFile: null,
    mediaFileSrc: null,
    mediaFileURL: null,
    isEditingMediaFile: false,
    errors: {
    },
    canAdd: true,
    canEdit: true,
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

  }

  componentDidUpdate = (prevProps, prevState) => {
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.loadMediaByID();
    }
  }

  loadMediaByID = () => {
    if(this.state.id){
      this.props.loadMedia(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({media: resp.data.content}, ()=> {
            
            this.setState(update(this.state, { media: { removeImage: {$set: [false, false, false]} }}), ()=> {
              this.mapEventToFields();
            });
          });
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  mapEventToFields = () => {
    this.mapContentSchedulingType();
    this.mapMediaFile();
  }

  getFileURL = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  mapContentSchedulingType = () => {

    let content_scheduling_type_id = '1';

    switch(this.state.media.content_type){
    case 'Attract Loop':
      content_scheduling_type_id = '1';
      break;
    case 'Campaign':
      content_scheduling_type_id = '2';
      break;
    default:
      break;
    }
    this.setState(update(this.state, { media: {content_scheduling_type_id: {$set: content_scheduling_type_id}}}));
  }

  handleContentSchedulingTypeChange = (e) => {
    this.setState(update(this.state, {media: {content_scheduling_type_id: {$set: e.target.value} }}));
  }

  handleOrientationChange = (e) => {
    this.setState(update(this.state, {media: {orientation: {$set: e.target.value}}}))
  }

  mapMediaFile = () => {
    if(this.state.media.media_attachment){
      if(this.state.media.media_attachment.media_type === 'image'){
        axios.get(this.state.media.media_attachment.media_url).then((resp) => {
          const content = new File([resp.data], this.state.media.media_attachment.media_url.split('/').pop(), {type: "image/*"});
          this.setState({mediaFile: content, mediaFileSrc: this.state.media.media_attachment.media_url});
        });
      } else if(this.state.media.media_attachment.media_type === 'video') {
        const content = new File([''], this.state.media.media_attachment.media_url.split('/').pop(), {type: this.state.media.media_attachment.media_mimetype});
        this.setState({mediaFile: content, mediaFileSrc: this.state.media.media_attachment.media_url, mediaFileURL: this.getFileURL(this.state.media.media_attachment.media_url)}, () =>{
          this.video1.current.load();
        });
      }
    }
  }

  handleMediaFileChange = (event) => {
    if(event.length){
      this.setState({mediaFile: event[0]}, () => { } );
      const reader  = new FileReader();
      if(event[0].type.match('image')){
    
        reader.onload = (e) => {
          this.setState({mediaFileSrc: e.target.result, isEditingMediaFile: true});
        };
        reader.readAsDataURL(event[0]);
      } else {
        reader.onload = (e) => {
          var mediaFileURL = URL.createObjectURL(event[0]);
          this.setState({mediaFileSrc: e.target.result, mediaFileURL, isEditingMediaFile: true}, () => {
            this.video1.current.load();
          });
        };
        reader.readAsArrayBuffer(event[0]);
      }
    }
  }

  handleMediaFileChangeError = (error, event) => {
    window.alert(`${error.message}`);
  }

  removeMediaFile = () => {
    this.setState(update(this.state, { mediaFile: {$set: null}, mediaFileSrc: {$set: null}, media: { removeImage: {[0]: {$set: true}}}}));
  }

  addMedia = () => {
    
    const media = Object.assign({}, this.state.media); 
    media.content_scheduling_type_id = parseInt(media.content_scheduling_type_id, 10);

    const data = new FormData()
    data.append('data', JSON.stringify(media));

    if(this.state.isEditingMediaFile){
      data.append('file', this.state.mediaFile);
    }

    this.props.addMedia(data, (resp) => {
      this.setState({added: true});
      this.props.loadMedias();
    });
  }

  editMedia = () => {
    
    const media = Object.assign({}, this.state.media);

    const data = new FormData()

    if(this.state.isEditingMediaFile){
      data.append('file', this.state.mediaFile);
    }

    data.append('data', JSON.stringify(media));

    this.props.editMedia(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadMedias();
    });
  }

  handleExternalURLChange = (e) => {
    this.setState(update(this.state, {media: {external_url: {$set: e.target.value}}}));
  }

  validateFields = () => {
    let flag = true;

    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/medias'/>;
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Media</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/medias'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addMedia} disabled={this.props.isAddingMedia || !this.state.canAdd} >Add Media</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editMedia} disabled={this.props.isEditingMedia || !this.state.canEdit} >Edit Media</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Media Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="cs_play_type_id">Media Files Type</label>
                    <select className="form-control" required id="cs_play_type_id" value={this.state.media.content_scheduling_type_id} onChange={this.handleContentSchedulingTypeChange}>
                      <option value="1">Attract Loop</option>
                      <option value="2">Campaign</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="orientation">Orientation</label>
                    <select className="form-control" required id="orientation" value={this.state.media.orientation} onChange={this.handleOrientationChange}>
                      <option value="Portrait" >Portrait</option>
                      <option value="Landscape" >Landscape</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="externalurl">External URL</label>
                    <input type="text" className="form-control" id="externalurl" value={this.state.media.external_url} onChange={this.handleExternalURLChange} placeholder="External URL" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="eventImage">Media File</label>
                    {this.state.mediaFile ? 
                      <div>
                        {(/video/gm).test(this.state.mediaFile.type) &&
                          <video width="300" height="200" controls ref={this.video1} style={{float: 'left', marginRight: '20px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}}>
                            <source type={`${this.state.mediaFile.type}`} src={`${this.state.mediaFileURL}`} />
                          </video>
                        }
                        {(/image/gm).test(this.state.mediaFile.type) &&
                          <div style={{backgroundImage: `url(${this.state.mediaFileSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        }
                        <div style={{float: 'left'}}>
                          {this.state.mediaFile.name} <br/>
                          {this.state.mediaFile.type} <br/>
                          {this.state.mode == 'Add' &&
                            <button className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeMediaFile} disabled={this.props.isAddingMedia}>Remove</button>
                          }
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="eventImage" accepts={['image/*', 'video/*']} clickable className="field-drop inputClass" onError={this.handleMediaFileChangeError} onChange={this.handleMediaFileChange} maxFileSize={100000000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add File</a></div>
                      </Files>
                    }
                    {this.props.isAddingMedia &&
                      <div className="progress" style={{marginTop: '20px'}}>
                        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{width: this.props.percentUploaded + '%'}}></div>
                      </div>
                    }
                    {this.state.mode === 'Add' &&
                      <small id="eventImageError" className="form-text text-muted" style={{marginBottom: '10px'}}>
                        Accepts: images/*, video/*<br/>
                        Max file size 100MB
                      </small>
                    }
                    
                  </div>

                </form>
              </div>
            </div>
          </div>


          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/medias'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addMedia} disabled={this.props.isAddingMedia || !this.state.canAdd} >Add Media</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editMedia} disabled={this.props.isEditingMedia || !this.state.canEdit} >Edit Media</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  medias: state.medias.medias,
  isLoadingMedia: state.medias.isLoadingMedia,
  isAddingMedia: state.medias.isAddingMedia,
  isEditingMedia: state.medias.isEditingMedia,
  percentUploaded: state.medias.percentUploaded,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadMedia,
      loadMedias,
      addMedia,
      editMedia,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MediaManagerEditor);


// WEBPACK FOOTER //
// ./src/modules/MediaManager/MediaManagerEditor.js